export enum ActType {
  SenzaAtto = '0',
  AttoDigitale = '1',
  AttoCartaceo = '2',
}
